import React, { FC } from "react";
import classes from "./Face.module.css";

interface IFaceProps {
  face: string;
  name: string;
  active: number;
  number: number;
  masterChangeHandler: (num: number) => void;
}

const Face: FC<IFaceProps> = ({
  face,
  name,
  active,
  number,
  masterChangeHandler,
}) => {
  const cls = [classes.Face];

  if (active === number) {
    cls.push(classes.Face_active);
  }

  return (
    <div className={cls.join(" ")} onClick={() => masterChangeHandler(number)}>
      <div className={classes.Face_wrapper}>
        <img className={classes.Face_pic} src={face} alt="master_face" />
      </div>
      <div className={classes.Face_name_wrapper}>
        <h3 className={classes.Face_name}>
          {name.split(" ").length === 2 ? (
            <>
              <span>{`${name.split(" ")[0]}`}</span>
              <br />
              <span>{`${name.split(" ")[1]}`}</span>
            </>
          ) : (
            name
          )}
        </h3>
      </div>
    </div>
  );
};

export default Face;
